var CategoryFilter = React.createClass({
  propTypes: {
    categories: React.PropTypes.array.isRequired,
    currentPath: React.PropTypes.string,
    onCategoryChanged:React.PropTypes.func
  },
  breakDownTaxonomy(taxPath) {
    return taxPath.split('//');
  },
  getDisplayValue(taxPath, index) {
    let splitTax = this.breakDownTaxonomy(taxPath);
    if (index == undefined) {
      index = splitTax.length - 1;
    }

    return splitTax[index];
  },
  getItem(category, indented) {
    if (RA.KBSearch.showBrowseHits) {
		return this.withHitCount(category, indented);
	} else {
		return this.withoutHitCount(category, indented);
	}
  },
  withHitCount(category, indented) {
	 let className = classNames("filter__item", {"-in2" : indented});
	 return (
      <li className={className} key={category.value}>
        <a href="#" className="filter__link" onClick={this.categoryClicked.bind(this, category.value)}>{this.getDisplayValue(category.value)}</a>
		&nbsp;<span class="text-muted">({category.hits})</span>
      </li>
    )
  },
  withoutHitCount(category, indented) {
	 let className = classNames("filter__item", {"-in2" : indented});
	 return (
      <li className={className} key={category.value}>
        <a href="#" className="filter__link" onClick={this.categoryClicked.bind(this, category.value)}>{this.getDisplayValue(category.value)}</a>
      </li>
    )
  },
  hasCurrentPath() {
    let currentPath = this.props.currentPath;
    return currentPath && currentPath.length;
  },
  getCurrentPathItems() {
    if (!this.hasCurrentPath()) return;

    let currentPath = this.props.currentPath;
    let items = [];

    // all categories
    items.push((
      <li className="filter__item" key="all">
        <a href="#" className="filter__link -back icon-link" onClick={this.categoryClicked.bind(this, "")}>
          <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{Labels.getLabel("All Categories")}</span>
        </a>
      </li>
    ));

    let paths = this.breakDownTaxonomy(currentPath);

    // all paths from start up to current path
    // Sage, starting array at 1 to avoid the blank item at the start of the list.
    for (let i = 1; i < paths.length - 1; i++) {
      let path = paths.slice(0, i + 1).join("//");

      items.push((
        <li className="filter__item" key={path}>
          <a href="#" className="filter__link -back icon-link" onClick={this.categoryClicked.bind(this, path)}>
            <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{paths[i]}</span>
          </a>
        </li>
      ));
    }

    // current path category name
    items.push(<li className="filter__item -in1 -active" key={currentPath}>{paths[paths.length - 1]}</li>);

    return items;
  },
  categoryClicked(category) {
    if (this.props.onCategoryChanged) {
      this.props.onCategoryChanged(category);
    }
  },

  render() {
    let categories = this.props.categories;

    if (categories.length == 0 && !this.hasCurrentPath()) {
      return <span />
    }

    let currentPathItems = this.getCurrentPathItems();
    let indented = this.hasCurrentPath();
    let items = categories.map(cat => this.getItem(cat, indented));

    return (
      <BrowseFilter title={Labels.getLabel("Categories")} filterType="filter-type__category" ariaLabel="Solution Category filter" isOpen={this.props.isOpen}>
        <CollapsingFilterList
          defaultItems={currentPathItems}
          items={items} />
      </BrowseFilter>
    )
  }
});